let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gbPTO")).then(() => parcelRequire('c81zX'));